module.exports = __webpack_public_path__ + "img/20170319-11-768x1024.d8462572.jpeg";